// Minimal modal base — duplicated from component-bundle-personalizer.js#NewModal
// to keep this component self-contained.
/* global bodyScrollLock */
class BundleBraceletModalBase extends HTMLElement {
  connectedCallback() {
    this.getElement();
    this.addEventListeners();
  }
  getElement() {
    this.buttonOpen = document.querySelector(".js-button-open");
    this.buttonClose = this.querySelector(".js-button-close");
    this.overlay = this.querySelector(".js-overlay");
    this.innerEl = this.querySelector(".js-personalizer-inner");
  }
  addEventListeners() {
    if (!this.buttonClose || !this.buttonOpen) return;
    this.buttonOpen.addEventListener("click", (e) => {
      e.preventDefault();
      this.open();
    });
    this.buttonClose.addEventListener("click", () => this.close());
    this.overlay.addEventListener("click", () => this.close());
  }
  open() {
    this.classList.add("open");
    document.body.classList.add("bundle-bracelet-personalizer-open");
    bodyScrollLock.disableBodyScroll(this.innerEl, { reserveScrollBarGap: true });
  }
  close() {
    this.classList.remove("open");
    document.body.classList.remove("bundle-bracelet-personalizer-open");
    bodyScrollLock.enableBodyScroll(this.innerEl);
  }
}

class BundleBraceletPersonalizer extends BundleBraceletModalBase {
  connectedCallback() {
    super.connectedCallback();
    this.itemTemplate = this.querySelector(".js-bundle-bracelet-item").outerHTML;
    this.updatePriceLabel();
  }

  getElement() {
    super.getElement();
    this.itemsContainer = this.querySelector(".js-items");
    this.familyInput = this.querySelector(".js-family-initials-input");
    this.initialsWrapper = this.familyInput.closest(".bundle-bracelet-personalizer__initials");
    this.addMoreBtn = this.querySelector(".js-button-add-more");
    this.addMoreSave = this.querySelector(".js-add-more-save");
    this.atcBtn = this.querySelector(".js-button-atc");
    this.atcLabel = this.querySelector(".js-atc-label");
    this.atcPrice = this.querySelector(".js-atc-price");
    this.atcOriginalPrice = this.querySelector(".js-atc-original-price");
    try {
      this.discountTiers = JSON.parse(this.dataset.discountTiers || "[0]");
    } catch (e) {
      this.discountTiers = [0];
    }
    this.personaPrices = {
      her: parseFloat(this.dataset.herPrice) / 100,
      him: parseFloat(this.dataset.himPrice) / 100,
      kid: parseFloat(this.dataset.kidPrice) / 100,
    };
    this.personaVariants = {
      her: this.dataset.herVariant,
      him: this.dataset.himVariant,
      kid: this.dataset.kidVariant,
    };
    const previewJson = this.querySelector(".js-preview-images")?.textContent;
    this.previewImages = previewJson ? JSON.parse(previewJson) : {};
    this.postAtcEl = this.querySelector(".js-post-atc");
    this.postAtcContent = this.postAtcEl.querySelector('.js-post-atc-inner')
    this.postAtcOverlay = this.querySelector(".js-post-atc-overlay");
    this.postAtcCloseBtn = this.querySelector(".js-post-atc-close");
    this.postAtcBackBtn = this.querySelector(".js-post-atc-back");
    this.postAtcNextBtn = this.querySelector(".js-post-atc-next");
  }

  addEventListeners() {
    super.addEventListeners();
    this.addItemListeners(this.itemsContainer.querySelector(".js-bundle-bracelet-item"));
    this.addMoreBtn.addEventListener("click", () => this.handleAddMore());
    this.atcBtn.addEventListener("click", () => this.handleAtc());
    if (this.postAtcCloseBtn) {
      this.postAtcCloseBtn.addEventListener("click", () => this.closePostAtcModal());
    }
    if (this.postAtcOverlay) {
      this.postAtcOverlay.addEventListener("click", () => this.closePostAtcModal());
    }
    if (this.postAtcBackBtn) {
      this.postAtcBackBtn.addEventListener("click", () => this.closePostAtcModal());
    }
    if (this.postAtcNextBtn) {
      this.postAtcNextBtn.addEventListener("click", () => { window.location.href = "/cart"; });
    }
  }

  addItemListeners(itemEl) {
    const wireGroup = (groupSelector, chipSelector, onSelect) => {
      itemEl.querySelectorAll(groupSelector).forEach((group) => {
        const chips = group.querySelectorAll(chipSelector);
        chips.forEach((chip) => {
          chip.addEventListener("click", () => {
            chips.forEach((c) => c.classList.remove("is-selected"));
            chip.classList.add("is-selected");
            if (onSelect) onSelect(itemEl, chip);
          });
        });
      });
    };
    wireGroup(".js-persona-chips", ".js-persona-chip", (el, chip) => {
      this.handlePersonaChange(el, chip.dataset.persona);
    });
    wireGroup(".js-cord-chips", ".js-cord-chip", (el) => {
      this.clearSectionError(el, "cord");
      this.updatePreview(el);
    });
    wireGroup(".js-finish-chips", ".js-finish-chip", (el) => {
      this.clearSectionError(el, "finish");
      this.updatePreview(el);
    });

    const removeBtn = itemEl.querySelector(".js-button-remove");
    if (removeBtn) {
      removeBtn.addEventListener("click", () => {
        itemEl.remove();
        this.relabelItems();
        this.updatePriceLabel();
      });
    }

    this.updatePreview(itemEl);
  }

  handlePersonaChange(itemEl, newPersona) {
    const prevPersona = itemEl.dataset.activePersona;
    itemEl.dataset.activePersona = newPersona;
    if (prevPersona !== newPersona) {
      itemEl.querySelectorAll(".js-cord-chips, .js-finish-chips").forEach((group) => {
        group.classList.toggle("is-active", group.dataset.persona === newPersona);
      });
      itemEl.querySelectorAll(".js-cord-chip.is-selected, .js-finish-chip.is-selected")
        .forEach((c) => c.classList.remove("is-selected"));
    }
    this.clearSectionError(itemEl, "persona");
    this.updatePreview(itemEl);
    this.updatePriceLabel();
  }

  handleAddMore() {
    const wrap = document.createElement("div");
    wrap.innerHTML = this.itemTemplate.trim();
    const newItem = wrap.firstChild;
    this.itemsContainer.appendChild(newItem);
    this.relabelItems();
    this.addItemListeners(newItem);
    this.updatePriceLabel();
  }

  relabelItems() {
    const items = this.itemsContainer.querySelectorAll(".js-bundle-bracelet-item");
    const labels = ["FIRST BRACELET", "SECOND BRACELET", "THIRD BRACELET", "FOURTH BRACELET"];
    items.forEach((item, i) => {
      item.dataset.index = i + 1;
      const labelEl = item.querySelector(".bundle-bracelet-item__label");
      if (labelEl) {
        labelEl.childNodes[0].nodeValue = labels[i] || `BRACELET ${i + 1}`;
      }
    });
  }

  updatePreview(itemEl) {
    const persona = itemEl.dataset.activePersona;
    const activeCordGroup = itemEl.querySelector(".js-cord-chips.is-active");
    const activeFinishGroup = itemEl.querySelector(".js-finish-chips.is-active");
    const cord = (activeCordGroup?.querySelector(".js-cord-chip.is-selected")
      || activeCordGroup?.querySelector(".js-cord-chip"))?.dataset.cord;
    const finish = (activeFinishGroup?.querySelector(".js-finish-chip.is-selected")
      || activeFinishGroup?.querySelector(".js-finish-chip"))?.dataset.finish;
    const img = itemEl.querySelector(".js-preview-image");
    if (!img || !persona) return;
    img.alt = `${persona} bracelet preview`;
    const url = cord && finish ? this.previewImages[`${cord}|${finish}`] : "";
    if (url) {
      img.src = url;
      img.style.background = "";
    } else {
      img.removeAttribute("src");
      img.style.background = "#f5f1ea";
    }
  }

  getTierDiscount(count) {
    if (count <= 0 || this.discountTiers.length === 0) return 0;
    const idx = Math.min(count, this.discountTiers.length) - 1;
    return (this.discountTiers[idx] || 0) / 100;
  }

  updatePriceLabel() {
    const items = this.itemsContainer.querySelectorAll(".js-bundle-bracelet-item");
    let subtotal = 0;
    items.forEach((item) => {
      const persona = item.dataset.activePersona;
      if (persona) subtotal += this.personaPrices[persona] || 0;
    });
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency });

    const discount = this.getTierDiscount(items.length);
    const total = Math.max(0, subtotal - discount);

    this.atcPrice.textContent = formatter.format(total);
    if (this.atcOriginalPrice) {
      if (discount > 0) {
        this.atcOriginalPrice.textContent = formatter.format(subtotal);
        this.atcOriginalPrice.hidden = false;
      } else {
        this.atcOriginalPrice.textContent = "";
        this.atcOriginalPrice.hidden = true;
      }
    }

    if (this.addMoreSave) {
      const nextDiscount = this.getTierDiscount(items.length + 1);
      if (nextDiscount > 0) {
        const formatted = formatter.format(nextDiscount).replace(/\.00$/, "");
        this.addMoreSave.textContent = `Save ${formatted} on total order`;
        this.addMoreSave.hidden = false;
      } else {
        this.addMoreSave.textContent = "";
        this.addMoreSave.hidden = true;
      }
    }
  }

  clearSectionError(itemEl, key) {
    const section = itemEl.querySelector(`.js-section[data-section-key="${key}"]`);
    if (section) section.classList.remove("is-error");
  }

  validate() {
    let firstInvalidEl = null;
    const markInvalid = (el) => {
      if (!firstInvalidEl) firstInvalidEl = el;
    };

    if (this.familyInput.value.trim() === "") {
      this.initialsWrapper.classList.add("is-error");
      markInvalid(this.initialsWrapper);
    } else {
      this.initialsWrapper.classList.remove("is-error");
    }

    this.itemsContainer.querySelectorAll(".js-bundle-bracelet-item").forEach((itemEl) => {
      const personaConfirmed = itemEl.querySelector(".js-persona-chip.is-selected");
      const personaSection = itemEl.querySelector('.js-section[data-section-key="persona"]');
      if (!personaConfirmed) {
        personaSection.classList.add("is-error");
        markInvalid(personaSection);
        return;
      }
      personaSection.classList.remove("is-error");

      const cordSection = itemEl.querySelector('.js-section[data-section-key="cord"]');
      const cordSelected = itemEl.querySelector(".js-cord-chips.is-active .js-cord-chip.is-selected");
      if (!cordSelected) {
        cordSection.classList.add("is-error");
        markInvalid(cordSection);
      } else {
        cordSection.classList.remove("is-error");
      }

      const finishSection = itemEl.querySelector('.js-section[data-section-key="finish"]');
      const finishSelected = itemEl.querySelector(".js-finish-chips.is-active .js-finish-chip.is-selected");
      if (!finishSelected) {
        finishSection.classList.add("is-error");
        markInvalid(finishSection);
      } else {
        finishSection.classList.remove("is-error");
      }
    });

    if (firstInvalidEl) {
      this.scrollSectionIntoView(firstInvalidEl);
      return false;
    }
    return true;
  }

  scrollSectionIntoView(el) {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  handleAtc() {
    if (!this.validate()) return;

    const items = [];
    this.itemsContainer.querySelectorAll(".js-bundle-bracelet-item").forEach((itemEl) => {
      const persona = itemEl.dataset.activePersona;
      const cord = itemEl.querySelector(".js-cord-chips.is-active .js-cord-chip.is-selected")?.dataset.cord;
      const finish = itemEl.querySelector(".js-finish-chips.is-active .js-finish-chip.is-selected")?.dataset.finish;
      items.push({
        id: this.personaVariants[persona],
        properties: {
          name: this.familyInput.value.trim(),
          cord: cord,
          color: finish,
        },
      });
    });

    this.atcBtn.disabled = true;
    this.atcLabel.textContent = "Adding to cart...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    })
      .then((r) => r.json())
      .then(() => {
        this.atcBtn.disabled = false;
        this.atcLabel.textContent = "Add to cart";
        this.openPostAtcModal();
      })
      .catch((err) => {
        console.error("bundle-bracelet ATC error:", err);
        this.atcBtn.disabled = false;
        this.atcLabel.textContent = "Add to cart";
      });
  }

  openPostAtcModal() {
    if (!this.postAtcEl) return;
    this.postAtcEl.classList.add("is-open");
    this.postAtcEl.setAttribute("aria-hidden", "false");
    bodyScrollLock.disableBodyScroll(this.postAtcContent, { reserveScrollBarGap: true });
  }

  closePostAtcModal() {
    if (!this.postAtcEl) return;
    this.postAtcEl.classList.remove("is-open");
    this.postAtcEl.setAttribute("aria-hidden", "true");
    bodyScrollLock.enableBodyScroll(this.postAtcContent);
  }
}

customElements.define("bundle-bracelet-personalizer", BundleBraceletPersonalizer);
